export const MODULE_SEARCH = "MODULE_SEARCH";
export const MODULE_SEARCH_RESPONSE = "MODULE_SEARCH_RESPONSE";
export const MODULE_GET = "MODULE_GET";
export const MODULE_GET_RESPONSE = "MODULE_GET_RESPONSE";